import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import Hero from "./../components/hero"
import CategoriesSlider from "./../components/categories"
import ProductsSlider from "./../components/products"
import News from "./../components/news"
import Reviews from "./../components/reviews"
import Lifestyle from "./../components/lifestyle"
import Works from "./../components/works"
import Why from "./../components/why"
import Story from "./../components/story"

const Home = () => {
  return (
    <Layout>
      <SEO title="Home" />
      <Hero />
      <CategoriesSlider />
      <News />
      <Lifestyle />
      <Works />
      <Why />
      <Reviews />
      <Story />
      <ProductsSlider />
    </Layout>
  )
}

export const query = graphql`
  query HomeQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default Home
